'use strict';

const {Unit} = require("../../custom_components/js/unit/Unit");
module.exports = (app) => app.filter('unit', ['translationService', function (translationService) {

    /**
     *
     * @param unece {string} the unece string to be formatted
     * @param quantity {number} the quantity of the unit for plural formatting
     */
    function convertUnece(unece, quantity = 1) {
        const unit = new Unit(unece, unece, translationService);

        return unit.getNameByQuantity(quantity);
    }

    return convertUnece;
}]);
